<template>
    <article class="l-section-n p-v-transition-ud episode">

        <!--- 話数セレクタ -->
        <ul class="l-section-n c-tabmenu c-tabmenu_max-200 c-tabmenu_noborder u-ft-sz-s episode__select">
            <li class="c-tabmenu__item" v-for="(episode, index) in episode_list" :key="index">
                <router-link :to="{name:'episode', params:{id:episode.id}}" class=" c-tabmenu__link ">
                    <span class="c-tabmenu__text ">{{episode.menu}}</span>
                </router-link>
            </li>
        </ul>

        <transition name="p-v-transition-ud">
            <div class="p-v-transition-ud episode__content" v-show="!is_loading">
                <header class="episode__header u-txt-center">
                    <h1>
                        <span class="episode__menu">{{episode.menu}}</span>
                        <span class="episode__title">{{episode.title}}</span>
                    </h1>
                </header>

                <div class="l-fx l-fx_wrap episode__images">
                    <div class="l-fx__item-3-1 l-fx__item-2-1-sp" v-for="(image, index) in episode.images" :key="index">
                        <img :src="image" alt="" class="u-sz-w100">
                    </div>
                </div>

                <div class="l-section-n-sp">
                    <p class="episode__story" v-html="episode.story"></p>
                    <p class="episode__staff u-txt-center" v-html="episode.staff"></p>
                </div>
            </div>
        </transition>

    </article>
</template>


<script>

// 各話データ
import episode_data from '../../js/page/story/episode_data';

export default {
    props: {
        is_loading: Boolean
    },
    data() {
        return {
            episode: Object,
            episode_temp: Object
        };
    },
    computed: {
        episode_list() {
            const story = this.$route.params.story;
            return episode_data.get_data('episode_list')[story];
        }
    },
    watch: {
        $route: 'change_episode'
    },
    methods: {
        // 話をチェンジする
        change_episode() {
            // URLパラメータで指定されたデータを取得
            const story = this.$route.params.story;
            const id = this.$route.params.id;

            // 話数無指定の場合は最新話
            if (!id) {
                const episode = episode_data.get_last_episode_from_story(story);
                this.$router.push({ name: 'episode', params: { id: episode.id } });
            } else {
                // プリロード
                this.load_images(story, id);
            }
        },
        // 画像をプリロードする
        load_images(story, id) {
            this.episode_temp = episode_data.get_episode_from_story_id(
                story, id);
            // 画像URLリスト
            const urls = this.episode_temp.images;
            episode_data.load_images(urls);
        }
    },
    created() {
        // 画像読み込み後の処理を登録する
        episode_data.$on('LOAD_IMAGES_COMPLETE', () => {
            this.episode = this.episode_temp;
        });


        this.change_episode();
    }
};
</script>



// WEBPACK FOOTER //
// episode-detail.vue?1cf252d4